import { useState, useEffect } from "react";
import { loadPackagetypeBySONumber, } from "../services/warehouseService";

const usePackageTypeListBySONumber = (Mode) => {
    const [packagetypelist, setPackagetypelist] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [selectedPakcagetype, setSelectedPakcagetype] = useState(null);
    const [selectedPakcagetypeID, setSelectedPakcagetypeID] = useState(null);
    // Fetch department data
    const fetchPackageTypeList = async (selectedID = null, selected_sonumber = null) => {
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1, p_so_number: selected_sonumber };

        try {
            const data = await loadPackagetypeBySONumber(para);
            if (data && data.length > 0) {
                setPackagetypelist(data);
                
                const initialWarehouse = data.find((obj) => obj.line_no === selectedID);

                if (initialWarehouse) { // ✅ Corrected check
                    setSelectedPakcagetype(initialWarehouse);
                    setSelectedPakcagetypeID(initialWarehouse.line_no);
                    setIsDataLoaded(true);
                }
                else {
                    setSelectedPakcagetype(null);
                    setSelectedPakcagetypeID(null);


                }

                return data;


            }

            if (selected_sonumber === null) {
                setSelectedPakcagetype(null);
                setSelectedPakcagetypeID(null);
                setPackagetypelist([]);
                setIsDataLoaded(false);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isDataLoaded) {
            fetchPackageTypeList();
        }
    }, [isDataLoaded]);

    // Function to load department based on selected ID
    const loadPackageTypeBySONumberAndID = async (selectedID, selected_sonumber) => {
        return  await fetchPackageTypeList(selectedID, selected_sonumber);
    };

    return {
        packagetypelist,
        selectedPakcagetype,
        setSelectedPakcagetype,
        selectedPakcagetypeID,
        setSelectedPakcagetypeID,
        loadPackageTypeBySONumberAndID,
    };
};

export default usePackageTypeListBySONumber;
